import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Modules } from "../../../constants/Module";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import {
  ProjectStatuses,
} from "../../../constants/Status";
import moment from "moment";
import { withTranslation } from "react-i18next";
function Project({ item, t }) {
  return (
    <>
      <div className="mx-2">
        <div>
          <strong>
            {" "}
            {ucFirst(item.payload.name)} ({item.project.uniqueProjectId}){" "}
          </strong>{" "}
           {item.event === Action.CREATE ? t("was created by") : t("was updated by")}
          <CreatorDetails creator={item?.creator} date={item?.createdAt} />
        </div>
        {item.event === Action.UPDATE && (
          <div>
            {item?.payload?.status &&
              typeof item?.payload?.status === "object" && item?.payload?.status !== null && (
                <div className="mx-2">
                  <div className="d-flex align-items-center change_status">
                    {item?.payload?.status?.new ===
                      ProjectStatuses.REJECTED && item?.payload?.status &&
                      item?.payload?.status?.old &&
                      item?.payload?.status?.new && (
                        <div className="mx-2">
                          <div className="d-flex align-items-center change_status">
                            <strong> {t('Status')}: </strong>
                            <div className="d-flex align-items-center mx-2">
                              <span>{item?.payload?.status?.old}</span>
                            </div>
                            <span className="middleArrow mx-2">
                              <ArrowRightAltOutlinedIcon />
                            </span>
                            <div className="d-flex align-items-center">
                              <span className="mx-2">{item?.payload?.status?.new}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    {item?.payload?.status?.new === ProjectStatuses.ONGOING &&
                      item?.payload?.status &&
                        item?.payload?.status?.old &&
                        item?.payload?.status?.new && (
                          <div className="mx-2">
                            <div className="d-flex align-items-center change_status">
                              <strong> {t('Status')}: </strong>
                              <div className="d-flex align-items-center mx-2">
                                <span>{item?.payload?.status?.old}</span>
                              </div>
                              <span className="middleArrow mx-2">
                                <ArrowRightAltOutlinedIcon />
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="mx-2">{item?.payload?.status?.new}</span>
                              </div>
                            </div>
                          </div>
                        )}
                    {item?.payload?.status?.new ===
                      ProjectStatuses.IN_APPROVAL && (
                      <div className="d-flex align-items-center change_status">
                        <span>
                          {t('Startup is')}{" "}
                          {item?.payload?.status?.old === ProjectStatuses.DRAFT
                            ? t("sent for approval")
                            : t("re-submitted")}{" "}
                          {t('by')}{" "}
                          <strong>
                            {item?.creator?.projectUsers[0]?.role?.name} [
                            {item?.creator?.name} |{" "}
                            {item?.creator?.uniqueUserId}]
                          </strong>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {item?.payload?.status?.new ===
                      ProjectStatuses.COMPLETED && item?.payload?.status &&
                      item?.payload?.status?.old &&
                      item?.payload?.status?.new && (
                        <div className="mx-2">
                          <div className="d-flex align-items-center change_status">
                            <strong> {t('Status')}: </strong>
                            <div className="d-flex align-items-center mx-2">
                              <span>{item?.payload?.status?.old}</span>
                            </div>
                            <span className="middleArrow mx-2">
                              <ArrowRightAltOutlinedIcon />
                            </span>
                            <div className="d-flex align-items-center">
                              <span className="mx-2">{item?.payload?.status?.new}</span>
                            </div>
                          </div>
                        </div>
                      )}
                      {item?.payload?.status?.new ===
                      ProjectStatuses.SENT_FOR_CONFIRMATION && item?.payload?.status &&
                      item?.payload?.status?.old &&
                      item?.payload?.status?.new && (
                        <div className="mx-2">
                          <div className="d-flex align-items-center change_status">
                            <strong> {t('Status')}: </strong>
                            <div className="d-flex align-items-center mx-2">
                              <span>{item?.payload?.status?.old}</span>
                            </div>
                            <span className="middleArrow mx-2">
                              <ArrowRightAltOutlinedIcon />
                            </span>
                            <div className="d-flex align-items-center">
                              <span className="mx-2">{item?.payload?.status?.new}</span>
                            </div>
                          </div>
                        </div>
                      )}
            {item?.payload?.name &&
            typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.description  && typeof item?.payload?.description === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Description')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.description?.old ? item?.payload?.description?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.description?.new ? item?.payload?.description?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {typeof item?.payload.projectCost === 'object' &&
            item?.payload?.projectCost?.old >= 0 &&
            item?.payload?.projectCost?.new >= 0 && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Startup Cost')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.projectCost?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.projectCost?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.projectType &&
            typeof item?.payload?.projectType === 'object' &&
            item?.payload?.projectType?.old?.name &&
            item?.payload?.projectType?.new?.name && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Startup Type')}: </strong>
                 <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.projectType?.old?.name}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.projectType?.new?.name}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.scope && typeof item?.payload?.scope === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Scope')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.scope?.old ? item?.payload?.scope?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.scope?.new ? item?.payload?.scope?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.tag &&
            typeof item?.payload?.tag === 'object' &&
            item?.payload?.tag?.old &&
            item?.payload?.tag?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Startup Tag')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.tag?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.tag?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.country &&
            typeof item?.payload?.country === 'object' &&
            item?.payload?.country?.old &&
            item?.payload?.country?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Country')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.country?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.country?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.state && typeof item?.payload?.state === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('State')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.state?.old ? item?.payload?.state?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.state?.new ? item?.payload?.state?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.city && typeof item?.payload?.city === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('City')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.city?.old ? item?.payload?.city?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.city?.new ? item?.payload?.city?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.technologyType &&
            typeof item?.payload?.technologyType === 'object' &&
            item?.payload?.state?.technologyType?.old &&
            item?.payload?.state?.technologyType?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Technology Type')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.technologyType?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.technologyType?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.projectOwner &&
            typeof item?.payload?.projectOwner === 'object' &&
            item?.payload?.projectOwner?.old?.name &&
            item?.payload?.projectOwner?.new?.name && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Startup Owner')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.projectOwner?.old?.name}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.projectOwner?.new?.name}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.projectSponsor &&
            typeof item?.payload?.projectSponsor === 'object' &&
            item?.payload?.projectSponsor?.old?.name &&
            item?.payload?.projectSponsor?.new?.name && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Startup Sponsor')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.projectSponsor?.old?.name}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.projectSponsor?.new?.name}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.projectAdmin &&
            typeof item?.payload?.projectAdmin === 'object' &&
            item?.payload?.projectAdmin?.old?.name &&
            item?.payload?.projectAdmin?.new?.name && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Founder')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.projectAdmin?.old?.name}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.projectAdmin?.new?.name}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.startDate &&
            item?.payload?.startDate?.old &&
            item?.payload?.startDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Start Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.startDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {moment(item?.payload?.startDate?.new).format("Do MMMM, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.endDate &&
            item?.payload?.endDate?.old &&
            item?.payload?.endDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('End Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.endDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{moment(item?.payload?.endDate?.new).format("Do MMMM, YYYY")}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.sector && typeof item?.payload?.sector === 'object' &&
            (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Sector')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.sector?.old ?? 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.sector?.new ?? 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.logo && typeof item?.payload?.logo === 'object' &&
            item?.payload?.logo?.old && item?.payload?.logo.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Logo')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.logo?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.logo?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.isRegister && typeof item?.payload?.isRegister === 'object' &&
            item?.payload?.isRegister?.old && item?.payload?.isRegister?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Registered')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isRegister?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isRegister?.new}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.pendingIps && typeof item?.payload?.pendingIps === 'object' && (item?.payload?.pendingIps?.old || item?.payload?.pendingIps?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Pending Ips')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.pendingIps?.old ?? 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.pendingIps?.new ?? 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
             { item?.payload?.grantedIps && typeof item?.payload?.grantedIps === 'object' && (item?.payload?.grantedIps?.old || item?.payload?.grantedIps?.new) &&  (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Granted Ips')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.grantedIps?.old ? item?.payload?.grantedIps?.old :'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.grantedIps?.new ? item?.payload?.grantedIps?.new :'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.isPotentialCustomer && typeof item?.payload?.isPotentialCustomer === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Potential Customer')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isPotentialCustomer?.old ?? 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isPotentialCustomer?.new ?? 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.fundStage && typeof item?.payload?.fundStage === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Fund Stage')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.fundStage?.old ? item?.payload?.fundStage?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.fundStage?.new ? item?.payload?.fundStage?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.isTRL && typeof item?.payload?.isTRL === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('TRL')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isTRL?.old ?? 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isTRL?.new ?? 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.salePlatform && typeof item?.payload?.salePlatform === 'object' && (item?.payload?.salePlatform?.old || item?.payload?.salePlatform?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Sale Platform')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.salePlatform?.old ? item?.payload?.salePlatform?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.salePlatform?.new ? item?.payload?.salePlatform?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {typeof item?.payload?.jobs === 'object' && (item?.payload?.jobs?.old >= 0 || item?.payload?.jobs?.new >=0) &&(
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Jobs')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.jobs?.old >= 0 && typeof item?.payload?.jobs?.old !== 'object' ? item?.payload?.jobs?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.jobs?.new >= 0 && typeof item?.payload?.jobs?.new !== 'object' ? item?.payload?.jobs?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {typeof item?.payload?.revenue === 'object' && (item?.payload?.revenue?.old >= 0 || item?.payload?.revenue?.new >= 0) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Revenue')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.revenue?.old >= 0 && typeof item?.payload?.revenue?.old !== 'object' ? item?.payload?.revenue?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.revenue?.new >= 0 && typeof item?.payload?.revenue?.new !== 'object' ? item?.payload?.revenue?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.investors !== null && typeof item?.payload?.investors === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Investors')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.investors?.old ? item?.payload?.investors?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.investors?.new ? item?.payload?.investors?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {typeof item?.payload?.valuation === 'object' && ((item?.payload?.valuation?.old >= 0 || item?.payload?.valuation?.new >=0)) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Valuation')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.valuation?.old >= 0 && typeof item?.payload?.valuation?.old !== 'object'  ? item?.payload?.valuation?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.valuation?.new >= 0 && typeof item?.payload?.valuation?.new !== 'object' ? item?.payload?.valuation?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.upcomingDesc !== null && typeof item?.payload?.upcomingDesc === 'object' && (item?.payload?.upcomingDesc?.old || item?.payload?.upcomingDesc?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> t('Upcoming Desc'): </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.upcomingDesc?.old ? item?.payload?.upcomingDesc?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.upcomingDesc?.new ? item?.payload?.upcomingDesc?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.marketSize  && typeof item?.payload?.marketSize === 'object' && (item?.payload?.marketSize?.old || item?.payload?.marketSize?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Market Size')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.marketSize?.old ? item?.payload?.marketSize?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.marketSize?.new ? item?.payload?.marketSize?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.isApproval && typeof item?.payload?.isApproval === 'object' && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Approval')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isApproval?.old ? item?.payload?.isApproval?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isApproval?.new ? item?.payload?.isApproval?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.isInvestor && typeof item?.payload?.isInvestor === 'object' &&
            item?.payload?.isInvestor?.old && item?.payload?.isInvestor?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Investor')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isInvestor?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isInvestor?.new}</span>
                  </div>
                </div>
              </div>
            )}
            { item?.payload?.analysis  && typeof item?.payload?.analysis === 'object' &&
            item?.payload?.analysis?.old && item?.payload?.analysis?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Analysis')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.analysis?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.analysis?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.invesmentAmount && typeof item?.payload?.invesmentAmount === 'object' && (item?.payload?.invesmentAmount?.old >= 0 || item?.payload?.invesmentAmount?.new >= 0) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Invesment Amount')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.invesmentAmount?.old >= 0 && typeof item?.payload?.invesmentAmount?.old !== 'object' ? item?.payload?.invesmentAmount?.old :  'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.invesmentAmount?.new >= 0 && typeof item?.payload?.invesmentAmount?.new !== 'object' ? item?.payload?.invesmentAmount?.new :'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
             {item?.payload?.progressDesc && typeof item?.payload?.progressDesc === 'object' && ( item?.payload?.progressDesc?.old || item?.payload?.progressDesc?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Progress Desc')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.progressDesc?.old ? item?.payload?.progressDesc?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.progressDesc?.new ? item?.payload?.progressDesc?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.upcomingDesc && typeof item?.payload?.upcomingDesc === 'object' && (item?.payload?.upcomingDesc?.old || item?.payload?.upcomingDesc?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Upcoming Desc')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.upcomingDesc?.old ? item?.payload?.upcomingDesc?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.upcomingDesc?.new ? item?.payload?.upcomingDesc?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.isOtherPotential && typeof item?.payload?.isOtherPotential === 'object' && (item?.payload?.isOtherPotential.old || item?.payload?.isOtherPotential.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Other Potential')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.isOtherPotential?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.isOtherPotential?.new}</span>
                  </div>
                </div>
              </div>
            )}
            {item?.payload?.analysisOther && typeof item?.payload?.analysisOther === 'object' && (item?.payload?.analysisOther?.old || item?.payload?.analysisOther?.new) && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Analysis Other')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.analysisOther?.old ? item?.payload?.analysisOther?.old : 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.analysisOther?.new ? item?.payload?.analysisOther?.new : 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
export default withTranslation()(Project);
